import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";


const NS = 'http://www.w3.org/2000/svg';

/**
 * All the possible SVG filters that can be applied
 */
export enum FilterType {
    Blend = 'feBlend',
    ColorMatrix = 'feColorMatrix',
    ComponentTransfer = 'feComponentTransfer',
    Composite = 'feComposite',
    ConvolveMatrix = 'feConvolveMatrix',
    DiffuseLighting = 'feDiffuseLighting',
    DisplacementMap = 'feDisplacementMap',
    Flood = 'feFlood',
    GaussianBlur = 'feGaussianBlur',
    Image = 'feImage',
    Merge = 'feMerge',
    Morphology = 'feMorphology',
    Offset = 'feOffset',
    SpecularLighting = 'feSpecularLighting',
    Tile = 'feTile',
    Turbulence = 'feTurbulence'
}

interface FilterElement extends React.SVGProps<SVGElement> {
    filterType: FilterType;
}

interface Filter {
    id: string;
    filters: FilterElement[];
}

interface SVGComponentProps extends React.DetailedHTMLProps<React.ObjectHTMLAttributes<HTMLObjectElement>, HTMLObjectElement> {
    path: string;
    filter?: Filter;
}

interface SVGComponentState {
}

class SVGComponent extends React.Component<SVGComponentProps, SVGComponentState> {
    private svg: SVGSVGElement;
    private filter: SVGFilterElement;

    constructor(props: SVGComponentProps) {
        super(props);
        bindAllOfThis(this, SVGComponent.prototype);
    }

    componentDidUpdate(prevProps: SVGComponentProps) {
        if (this.props !== prevProps && this.svg) {
            this.restyleSVG();
        }
    }

    private onLoad(e: any) {
        // If an onLoad function is specified, call it
        if (this.props.onLoad) {
            this.props.onLoad(e);
        }

        this.svg = e.currentTarget.contentDocument.rootElement;

        this.restyleSVG();
    }

    private restyleSVG() {
        if (this.svg != null) {
            let i = 0;

            // If a style was provided, then apply the attributes to the SVG
            let length = this.svg.children.length;
            if (this.props.style) {
                for (i = 0; i < length; ++i) {
                    for (var attribute in this.props.style) {
                        if (this.props.style[attribute]) {
                            this.svg.children[i].setAttribute(attribute, this.props.style[attribute]);
                        }
                    }
                }
            }

            // If a filter was provided, then create DOM elements to apply filter to SVG
            if (this.props.filter != null) {
                // Make sure the filter is referenced
                for (i = 0; i < length; ++i) {
                    this.svg.children[i].setAttribute('filter', 'url(#' + this.props.filter.id + ')');
                }

                // Create filter element
                let filter = document.createElementNS(NS, 'filter');
                filter.setAttribute('id', this.props.filter.id);

                // Add filter types to filter element
                length = this.props.filter.filters.length;
                for (i = 0; i < length; ++i) {
                    filter.appendChild(this.createFilter(this.props.filter.filters[i]));
                }

                if (this.svg.contains(this.filter)) {
                    this.svg.removeChild(this.filter);
                }

                this.filter = this.svg.appendChild(filter);
            }
        }
    }

    private createFilter(filter: FilterElement) {
        let { filterType, ...props } = filter;

        // Create the filter type and set it's attributes
        let filterElement = document.createElementNS(NS, filterType);
        for (var attribute in props) {
            if (props[attribute]) {
                filterElement.setAttribute(attribute, props[attribute]);
            }
        }
        return filterElement;
    }

    render() {
        let { data, filter, onLoad, path, type, ...props } = this.props;
        if (!path && data) {
            path = data;
        }

        return <object {...props} data={path} type='image/svg+xml' onLoad={this.onLoad}>
            {this.props.children}
        </object>;
    }
}

export default SVGComponent;



// WEBPACK FOOTER //
// ./src/components/common/SVGComponent.tsx